
export enum ActionType {
    AMOUNT_TEXT = 'AMOUNT_TEXT'
}

export interface ActionPaymentDialog {
    type: ActionType.AMOUNT_TEXT,
    text : string
}

type Action = ActionPaymentDialog

export default Action